import { Stepper } from '@mantine/core';

import { SplashLoader } from '~/domains/common/components/SplashLoader/SplashLoader';
import type { BRANDS } from '~/domains/auth/consts';

import { StepsHeader } from './StepsHeader';
import useStyles from './SignUpStepper.styles';
import useSignUpStepper from './useSignUpStepper';
import { RestrictedDomain } from './components/RestrictedDomain';
import { useSignUpSteps } from './useSignUpSteps';

interface CustomStepperProps {
  startFromKyc?: boolean;
}

function CustomStepper({ startFromKyc }: CustomStepperProps) {
  const { classes } = useStyles();
  const {
    activeStepIndex,
    brand,
    formKYC,
    formSignUp,
    isFormLoading,
    prevStep,
    steps,
    user,
    isRestrictedDomain,
    handleSetEmail,
    handleSetPassword,
    handleSetHandle,
    isHandleLoading,
    handleSetAddress,
    handleSkipKYC,
    handleKeyDownHandle,
    isProveKycEnabled,
    isProveInitializing,
    verifyType,
    handleSelectVerifyType,
    handleProveSendCode,
    handleEditInfo,
    isEditingFromConfirm,
    isKycLoading,
    preAuthStepCount,
  } = useSignUpStepper({ startFromKyc });

  const signUpSteps = useSignUpSteps({
    steps,
    user,
    brand: brand as BRANDS,
    formSignUp,
    formKYC,
    isProveKycEnabled,
    verifyType,
    isProveInitializing,
    isRestrictedDomain,
    handleSetEmail,
    handleSetPassword,
    handleSetHandle,
    isHandleLoading,
    handleKeyDownHandle,
    handleSelectVerifyType,
    handleProveSendCode,
    handleSetAddress,
    handleEditInfo,
    isEditingFromConfirm,
    isKycLoading,
    preAuthStepCount,
  });

  if (isFormLoading) {
    return <SplashLoader />;
  }

  return (
    <div className={classes.container}>
      <form>
        <StepsHeader
          currentStepIndex={activeStepIndex}
          steps={steps}
          prevStep={prevStep}
          brand={brand as BRANDS}
          onSkipKYCClick={handleSkipKYC}
          preAuthStepCount={preAuthStepCount}
        />

        <Stepper active={activeStepIndex}>
          {steps.map((label) => (
            <Stepper.Step key={label} label={label} className={classes.hiddenStep} />
          ))}
          <Stepper.Step className={classes.hiddenStep} />
        </Stepper>

        {isRestrictedDomain && <RestrictedDomain />}
        {signUpSteps[activeStepIndex]?.render()}
      </form>
    </div>
  );
}

export default CustomStepper;
